import { useState, useEffect } from 'react';

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
        console.log("useMediaQuery")
      setMatches(media.matches);
    }
    const listener = () => {
      setMatches(media.matches);
    };
    //media.addListener(listener);
    media.addEventListener(window, listener)
    //return () => media.removeListener(listener);
    return () => media.removeEventListener(window, listener)
  }, [matches, query]);

  return matches;
}